<h4 mat-dialog-title>Scelta tipo</h4>
<div mat-dialog-content>
    <p>Seleziona un tipo:</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close('altroSoggetto')">Altro soggetto</button>
    <button mat-button (click)="close('fabbricato')">Fabbricato</button>
</div>